module.exports = __webpack_public_path__ + "static/media/My Country.45e3aed6.jpg";